import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpModule } from '@angular/http';

import { HttpAPIWrapper } from "../shared/helpers/http-api-wrapper";
import { AuthService } from './auth.service';
import { LoggedInGuard } from './logged-in.guard';
import { LoginComponent } from './login.component';
import { LoginFormComponent } from './login-form.component';


@NgModule({
  imports: [
    FormsModule,
    HttpModule
  ],
  declarations: [
    LoginComponent,
    LoginFormComponent
  ],
  providers: [
    AuthService,
    HttpAPIWrapper,
    LoggedInGuard
  ]
})

export class AuthModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/auth/auth.module.ts
 **/